import { WorkerMind } from 'types/worker_mind'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'worker_minds'

export const requests = {
  fetchWorkerMinds: async (
    page: number,
    limit: number,
    is_display?: boolean,
    job_id?: number,
  ) => {
    return await axiosForGigbaseBiz.get<DataResponse<WorkerMind[]>>(resource, {
      params: {
        page,
        limit,
        is_display,
        job_id,
      },
    })
  },
  fetchWorkerMindCount: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<{ total: number }>>(
      `${resource}/unprocessed_count`,
    )
  },
  update: async (id: string, is_display: boolean) => {
    return await axiosForGigbaseBiz.patch<DataResponse<WorkerMind>>(
      mergeURL(resource, id.toString()),
      { is_display },
    )
  },
}
